import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';

import { ContentsRoutingModule } from './contents-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ContentListingComponent } from './content-listing/content-listing.component';
import { ContentGroupListingComponent } from './content-group-listing/content-group-listing.component';
import { ContentInfoComponent } from './content-info/content-info.component';
import { ContentPreviewComponent } from './content-preview/content-preview.component';
import { EditGroupNameComponent } from './edit-group-name/edit-group-name.component';
import { EditContentComponent } from './edit-content/edit-content.component';
import { UserReplayListingComponent } from './user-replay-listing/user-replay-listing.component';
import { EditUserReplayComponent } from './edit-user-replay/edit-user-replay.component';
import { QuickResponseListComponent } from './quick-response-list/quick-response-list.component';
import { EditQuickResponseComponent } from './edit-quick-response/edit-quick-response.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TestContentComponent } from './content-info/test-content/test-content.component';
import { VsmCommentsComponent } from './vsm-comments/vsm-comments.component';
import { EditVsmCommentsComponent } from './edit-vsm-comments/edit-vsm-comments.component';
import { AddContentCodeComponent } from './add-content-code/add-content-code.component';
import { PreviewMasterContentComponent } from './preview-master-content/preview-master-content.component';
import { EditMasterContentComponent } from './edit-master-content/edit-master-content.component';
import { ContentInfoMobileRowComponent } from './content-info/content-info-mobile-row/content-info-mobile-row.component';
import { ContentGroupListingMobileRowComponent } from './content-group-listing/content-group-listing-mobile-row/content-group-listing-mobile-row.component';

@NgModule({
  declarations: [
    ContentListingComponent,
    ContentGroupListingComponent,
    ContentInfoComponent,
    ContentPreviewComponent,
    EditGroupNameComponent,
    EditContentComponent,
    UserReplayListingComponent,
    EditUserReplayComponent,
    QuickResponseListComponent,
    EditQuickResponseComponent,
    TestContentComponent,
    VsmCommentsComponent,
    EditVsmCommentsComponent,
    AddContentCodeComponent,
    PreviewMasterContentComponent,
    EditMasterContentComponent,
    ContentInfoMobileRowComponent,
    ContentGroupListingMobileRowComponent,
  ],
  imports: [
    CommonModule,
    ContentsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    FontAwesomeModule,
  ],
})
export class ContentsModule {}
